import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const profileRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROFILE,
    name: 'PROFILE',
    component: () => import('./ProfilePage.vue'),
    meta: { requiresAuth: true, title: 'Profile' },
  },
  {
    path: routes.SETTINGS,
    name: 'SETTINGS',
    component: () => import('./SettingsPage.vue'),
    meta: { requiresAuth: true, title: 'Settings' },
  },
  {
    path: routes.DOCUMENT_PREVIEW,
    name: 'DOCUMENT_PREVIEW',
    component: () => import('./DocumentPreviewPage.vue'),
    meta: { requiresAuth: true, title: 'Document Preview' },
  },
  {
    path: routes.PROFILE_POLICIES,
    name: 'PROFILE_POLICIES',
    component: () => import('./PoliciesLegalPage.vue'),
    meta: { requiresAuth: true, title: 'Policies & Legal' },
  },
]
